import BrightnessDetector from "./BrightnessDetector";

export default BrightnessDetector;
